import { useState } from 'react';
import { loginUser } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';
import { Input, Btn } from '../components/UI';

export default function LoginPage() {
  const { login } = useAuth();
  const [code, setCode]     = useState('');
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    if (!code) { setError('Введите код'); return; }
    setLoading(true); setError('');
    try {
      const user = await loginUser(code);
      login(user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.screen}>
      <div style={styles.card}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src={process.env.PUBLIC_URL + '/logo.png'} alt="OPEN Field Hub"
               style={{ height: 44, maxWidth: '100%', display: 'block', margin: '0 auto 18px' }} />
          <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--accent-dark)' }}>Табель выходов</div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>Учёт статусов и планирование выходов</div>
        </div>

        <form onSubmit={handleLogin}>
          <Input label="Ваш код" value={code} onChange={setCode} placeholder="sv_1054-SV061 или bereza" />

          <div style={{ fontSize: 11, color: 'var(--text-light)', marginTop: -8, marginBottom: 16 }}>
            Код выдаётся администратором при добавлении в систему
          </div>

          {error && (
            <div style={{ background: 'var(--red-bg)', color: 'var(--red)', padding: '10px 12px', borderRadius: 6, fontSize: 13, marginBottom: 14 }}>
              {error}
            </div>
          )}

          <Btn size="full" color="primary" disabled={loading}>
            {loading ? 'Подождите...' : 'Войти'}
          </Btn>
        </form>
      </div>
    </div>
  );
}

const styles = {
  screen: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg, var(--accent-dark) 0%, var(--accent) 100%)',
    padding: 24,
  },
  card: {
    background: 'white', borderRadius: 16, padding: '40px 32px',
    width: '100%', maxWidth: 360,
    boxShadow: '0 20px 60px rgba(0,0,0,.2)',
  },
};
